/**
 * Fechas sin hora ("YYYY-MM-DD") que manda o espera el backend. Se leen como fecha local:
 * `new Date("2026-09-01")` la toma como UTC y en Argentina se muestra el día anterior.
 */

export function parseDateOnly(value: string | null | undefined): Date | null {
    if (!value) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (!match) return null;
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

/** "dd/mm/aaaa", o "—" si no hay fecha. */
export function formatDateOnly(value: string | null | undefined): string {
    const date = parseDateOnly(value);
    return date ? date.toLocaleDateString('es-AR') : '—';
}

export function toDateOnly(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
